/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Error_HintInputs */



/**
* | output |
* | --- |
* | "Open Code to inspect it, or ask the assistant to fix it." |
*
* @param {Canvas_Error_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_error_hint = /** @type {((inputs?: Canvas_Error_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Error_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Öffne den Code zur Prüfung oder bitte den Assistenten um eine Korrektur.")
	return /** @type {LocalizedString} */ ("Open Code to inspect it, or ask the assistant to fix it.")
});